// extracted by mini-css-extract-plugin
export var cardTitle = "_hs-1";
export var commentBubble = "_hs-e";
export var commentForm = "_hs-a";
export var commentInput = "_hs-b";
export var commentLabel = "_hs-d";
export var commentPrompt = "_hs-9";
export var csatCard = "_hs-0";
export var feedbackSection = "_hs-7";
export var starDisabled = "_hs-6";
export var starEmpty = "_hs-5";
export var starFilled = "_hs-4";
export var starWrapper = "_hs-3";
export var starsContainer = "_hs-2";
export var submittedComment = "_hs-c";
export var thankYouText = "_hs-8";